import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function UpgradeBanner() {
  const { teacher, isLightweightAccount, isSubscriber } = useAuth();

  if (!teacher || isSubscriber) return null;

  // Lightweight TpT account — prompt to create a full account to save progress
  if (isLightweightAccount) {
    return (
      <div style={{
        backgroundColor: '#fffbeb',
        borderBottom: '1px solid #fcd34d',
        padding: '10px 24px',
        fontSize: '13px',
        color: '#92400e',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        flexWrap: 'wrap',
        textAlign: 'center',
      }}>
        <span>
          You're using a session-only account. Create a free account to save your progress between visits.
        </span>
        <Link
          to="/signup?upgrade=true"
          style={{
            color: '#92400e',
            fontWeight: '600',
            textDecoration: 'underline',
            whiteSpace: 'nowrap',
          }}
        >
          Save my account →
        </Link>
      </div>
    );
  }

  // Full account but not a subscriber — prompt to subscribe for full library
  return (
    <div style={{
      backgroundColor: '#eff6ff',
      borderBottom: '1px solid #93c5fd',
      padding: '10px 24px',
      fontSize: '13px',
      color: '#1e40af',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      flexWrap: 'wrap',
      textAlign: 'center',
    }}>
      <span>
        You have access to your TpT novel{teacher?.tpt_novels?.length > 1 ? 's' : ''}.
        Subscribe for the full library and custom uploads.
      </span>
      <Link
        to="/subscribe"
        style={{
          color: '#1e40af',
          fontWeight: '600',
          textDecoration: 'underline',
          whiteSpace: 'nowrap',
        }}
      >
        Subscribe for $19.99/yr →
      </Link>
    </div>
  );
}
